import Button from './Button';

const EditButton = {
    extends : Button,
    props   : {
        text   : { type : String, default : 'Edit' },
        icon   : { type : String, default : 'fa fa-pencil' },
        design : { type : String, default : 'basic' },
        size   : { type : String, default : 'xs' }
    }
};

export default EditButton;
